import _ from 'underscore'
import React, { PropTypes } from 'react'
import { IndexLink, Link, withRouter } from 'react-router'
import { defineMessages, FormattedMessage } from 'react-intl'

import Locale from './Locale.jsx'
import Time from './Time.jsx'
import Menu from './Menu.jsx'
import Authenticated from './Authenticated.jsx'
import SignIn from './SignIn.jsx'
import Freebet from './Freebet.jsx'
import Loader from '../../../shared/components/Loader.jsx'

import { openBetsolutionGameWindow } from '../../../config/games'
import { connect } from 'react-redux'
import { isAvailableGames } from '../../../shared/utils/functions.js'
import { isFpBet, isRingo } from 'shared/domainUtils'

const messages = defineMessages({
    fast_sport: {
        id: 'header.navigation.fastsport',
        defaultMessage: 'Быстрые игры',
    },
    sports: {
        id: 'header.navigation.sports',
        defaultMessage: 'Спорт'
    },
    live: {
        id: 'header.navigation.live',
        defaultMessage: 'Лайв'
    },
    cybersport: {
        id: 'header.navigation.cybersport',
        defaultMessage: 'Киберспорт'
    },
    results: {
        id: 'header.navigation.results',
        defaultMessage: 'Результаты'
    },
    promotions: {
        id: 'header.navigation.promotions',
        defaultMessage: 'Акции и бонусы'
    },
    more: {
        id: 'header.navigation.more',
        defaultMessage: 'Ещё'
    },
    help: {
        id: 'header.help',
        defaultMessage: 'Помощь'
    },
    games: {
        id: 'header.games',
        defaultMessage: 'Игры'
    },
});

const NavbarLink = ({to, className, component, children}) => {
    const Comp = component || Link;

    return (
        <Comp to={to} className={className} activeClassName="active">
            {children}
        </Comp>
    );
};

class Header extends React.Component {
    static propTypes = {
        languageId: PropTypes.number.isRequired,
        user: PropTypes.any,
        freebet: PropTypes.any,
        balance: PropTypes.any,
        newMessagesCount: PropTypes.any,
        userGridSelection: PropTypes.object.isRequired,
        domain: PropTypes.string.isRequired,
        sportId: PropTypes.any,
        leagueId: PropTypes.any
    };

    state = { loading: false}

    constructor(props) {
        super(props);

        this._handleHelpClick = this._handleHelpClick.bind(this);
        this._handlePromotionsClick = this._handlePromotionsClick.bind(this);
        this._handleHiddenMenuClick = this._handleHiddenMenuClick.bind(this);
        this._onDocumentClick = this._onDocumentClick.bind(this);
    }

    componentDidUpdate() {
        if (this.state.openHiddenMenu) {
            document.addEventListener('click', this._onDocumentClick);
        }
    }

    componentWillMount() {
        this.setState({openHiddenMenu: false});
        document.removeEventListener('click', this._onDocumentClick);
    }

    _handleHelpClick(e) {
        e.preventDefault();
        const {domain} = this.props;

        window.open('//help.' + domain + '/faq', 'MyAccount',
            "toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650");
    }

    _handleResultsClick(link, e) {
        e.preventDefault();
        const {domain} = this.props;

        window.open('//results.' + domain + link, 'Results',
            "toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650");
    }

    _handlePromotionsClick(e) {
        e.preventDefault();
        const {user, domain} = this.props;

        if (user) {
            window.open('//members.' + domain + '/bonus/campaign', 'Promotions',
                "toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650");
        } else {
            window.open('//info.' + domain + '/promotions', 'Promotions',
                "toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650");
        }
    }

    _onDocumentClick() {
        document.removeEventListener('click', this._onDocumentClick);

        this.setState({
            openHiddenMenu: false
        });
    }

    _handleHiddenMenuClick() {
        this.setState({openHiddenMenu: this.state.openHiddenMenu ? false : true});
    }

    clickBetsolution = () => {
        const gamblerId = this.props.user ? this.props.user.get('gamblerId') : null
        const game = { id: 7001, productId: 3, type: "betsolutions", name: "Zeppelin" }
        this.setState({ loading: true })

        if (gamblerId) {
            fetch(`/api/games-betsolutions/`)
                .then((r) => r.json())
                .then(({token}) => {
                this.loadGame(game, token)
                })
            } else {
            if (game.productId === 2) {
                this.loadGame(game)
            } else {
                this.props.dispatch({ type: 'BEGIN_SIGNIN' })
                this.setState({ loading: false })
            }
        }
    }

    loadGame = (game, token) => {
        const config = {
        Token: token ? token : '54D2A7CA-FD87-46D4-A5A0-6BC0372C43EE',
        MerchantId: token ? 5096 : 105,
        GameId: game.id,
        ProductId: game.productId,
        IsFreeplay: 1,
        Lang: this.props.languageId === 5 ? 'en-US' : 'ru-RU',
        Platform: 'desktop',
        IframeContainerId: 'iframeContainer',
        IframeId: 'gameIFrame',
        GameOpenType: 'iframe',
        AuthUrl: token
            ? 'https://auth-ru.betsolutions.com/auth/auth/'
            : 'https://auth-tr.betsolutions.com/auth/auth/',
        }
        if (game.productId === 1) {
            config.TableGamesLobbyPageId = 1
            if (!token) {
                config.MerchantId = 34
                config.Token = '17B437DF-AB78-44CB-904F-621704BC610F'
            }
        }
        if (token) {
            config.IsFreeplay = 0
        }
        openBetsolutionGameWindow(config)
        this.setState({ loading: false })
    }

    render() {
        const {languageId, user, freebet, balance, newMessagesCount, countryCode,
               userGridSelection, domain, sportId, leagueId} = this.props;
        const isAvailable = isAvailableGames(countryCode);
        const isUz = countryCode === "UZ";

        const authenticatedProps = {
            user,
            balance: balance || 0,
            newMessagesCount: newMessagesCount || 0,
            domain
        };

        const sportDefined = (sportId !== undefined && sportId !== null && sportId.length);
        const leagueDefined = (leagueId !== undefined && leagueId !== null && leagueId.length);
        const sportMenuClassName = (sportDefined || leagueDefined) ? 'active' : null;

        let freebetProps;
        if (user && freebet) {
            freebetProps = {
                freebet,
                resourceId: user.get('resourceId'),
                languageId,
                domain
            };
        }

        const preMatchLinkAttr = userGridSelection.get('lastShown');
        const preMatchSportId = !preMatchLinkAttr ? null : preMatchLinkAttr.get('sportId');
        const preMatchLeagueId = !preMatchLinkAttr ? null : preMatchLinkAttr.get('leagueId', null);
        const preMatchLink = _.compact(['/sports', preMatchSportId, preMatchLeagueId]).join('/');

        const resultsDomain = '//results.' + domain;
        const membersDomain = '//members.' + domain;
        const infoDomain = '//info.' + domain;

        const hiddenMenuClass = this.state.openHiddenMenu ? "hidden-menu open" : "hidden-menu";

        const isFreebet = (freebet && user) ? ' with-freebet' : '';

        return (
            <header id="header" className={"header wrapper" + isFreebet}>
            {this.state.loading && <Loader />}
                <div className="settings cf">
                    <Locale/>
                    <Time languageId={languageId} />
                </div>
                <div className="header-bottom">
                    <Menu domain={domain} countryCode={countryCode} user={user}/>
                    <div className="logo pull-left">
                        <NavbarLink to="/" component={IndexLink}/>
                    </div>
                    <nav className="nav pull-left">
                        <ul>
                            <li>
                                <NavbarLink to={preMatchLink} className={sportMenuClassName}>
                                    <FormattedMessage {...messages.sports} />
                                </NavbarLink>
                            </li>
                            <li>
                                <NavbarLink to="/live">
                                    <FormattedMessage {...messages.live} />
                                </NavbarLink>
                            </li>
                            {(isFpBet || isUz) &&
                              <li>
                                  <NavbarLink to="/games" target="_blank" style={{position: 'relative'}}>
                                      <FormattedMessage {...messages.games}/>
                                  </NavbarLink>
                              </li>
                            } 
                            {isRingo &&
                              <li>
                                  <NavbarLink to="/games" target="_blank" style={{position: 'relative'}}>
                                      <FormattedMessage {...messages.fast_sport}/>
                                  </NavbarLink>
                              </li>
                            }
                            {isRingo && (
                                <li>
                                    <NavbarLink to="/cybersport">
                                        <FormattedMessage {...messages.cybersport} />
                                    </NavbarLink>
                                </li>
                            )}
                            <li className="visible-lg-block">
                                <a href={resultsDomain} target="_blank"
                                   onClick={this._handleResultsClick.bind(this, "/sports")}>
                                    <FormattedMessage {...messages.results} />
                                </a>
                            </li>
                          
                            {!isAvailable && <li className="visible-lg-block">
                                {user &&
                                <a href={membersDomain} className="promotions" target="_blank" onClick={this._handlePromotionsClick}>
                                    <FormattedMessage {...messages.promotions} />
                                </a>}
                                {!user &&
                                <a href={infoDomain} className="promotions" target="_blank" onClick={this._handlePromotionsClick}>
                                    <FormattedMessage {...messages.promotions} />
                                </a>}
                            </li>}
                            <li className="stretch"/>
                        </ul>
                    </nav>
                    <div className="hidden-menu-wrap visible-md-block">
                        <div className={hiddenMenuClass} onClick={this._handleHiddenMenuClick.bind(this)}>
                            <div className="items">
                                <a href={resultsDomain} target="_blank" onClick={this._handleResultsClick.bind(this, "/sports")}>
                                    <span className="arrow" />
                                    <FormattedMessage {...messages.results} />
                                </a>
                                {!isAvailable && <a href={membersDomain} target="_blank" onClick={this._handlePromotionsClick}>
                                    <FormattedMessage {...messages.promotions} />
                                </a>}
                            </div>
                        </div>
                    </div>
                    <div className="actions pull-right">
                        {(freebet && user) && <Freebet {...freebetProps}/>}
                        <a href={"//help." + domain + "/faq"}
                           className="help"
                           onClick={this._handleHelpClick}
                           target="_blank">
                           ?
                        </a>
                        {!user && <SignIn languageId={languageId}/>}
                        {user && <Authenticated {...authenticatedProps} />}
                    </div>
                </div>
            </header>
        );
    }
}

export default connect()(withRouter(Header))


// WEBPACK FOOTER //
// ./js/sport-betting/components/header/Header.jsx